import { Box } from '#/box';
import type { MultiBufferStream } from '#/buffer';

export class dac3Box extends Box {
  static override readonly fourcc = 'dac3' as const;
  box_name = 'AC3SpecificBox' as const;

  fscod: number;
  bsid: number;
  bsmod: number;
  acmod: number;
  lfeon: number;
  bit_rate_code: number;

  parse(stream: MultiBufferStream) {
    const tmp_byte1 = stream.readUint8();
    const tmp_byte2 = stream.readUint8();
    const tmp_byte3 = stream.readUint8();
    this.fscod = tmp_byte1 >> 6;
    this.bsid = (tmp_byte1 >> 1) & 0x1f;
    this.bsmod = ((tmp_byte1 & 0x1) << 2) | ((tmp_byte2 >> 6) & 0x3);
    this.acmod = (tmp_byte2 >> 3) & 0x7;
    this.lfeon = (tmp_byte2 >> 2) & 0x1;
    this.bit_rate_code = (tmp_byte2 & 0x3) | ((tmp_byte3 >> 5) & 0x7);
  }
}
